import { makeStyles } from '@mui/styles'
import {
  ERROR,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  PERIWINKLE,
  SHAMROCK,
  SLATE_GREY,
} from '@returnmates/client-core/src/constants/colors'

import { POPPINS } from '../../constants/styles/fonts'

const useStyles = makeStyles(() => ({
  main: {
    minWidth: '100%',
    minHeight: '100vh',
    display: 'flex',
  },
  spinnerWrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#FFFFFF',
    zIndex: 1,
  },
  mainPart: {
    display: 'inline-flex',
    width: 'calc(100% - 402px)',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  signIn: {
    position: 'absolute',
    top: 24,
    right: 48,
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '160%',
    color: SLATE_GREY,
  },
  link: {
    color: SHAMROCK,
  },
  logo: {
    width: 160,
  },
  header: {
    marginTop: 20,
    fontFamily: POPPINS,
    fontWeight: 600,
    fontSize: 50,
    lineHeight: '130%',
    textAlign: 'center',
    maxWidth: 568,
    color: MIDNIGHT_EXPRESS,
    '& > span': {
      color: SHAMROCK,
    },
  },
  mobileLabel: {
    display: 'none',
    marginTop: 10,
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '25.6px',
    textAlign: 'center',
    color: SLATE_GREY,
  },
  googleButton: {
    width: 400,
    marginTop: 30,
    '&:hover': {
      border: `1px solid ${NEON_BLUE_LIGHT}`,
    },
  },
  orSeparator: {
    width: 400,
    height: 1,
    backgroundColor: PERIWINKLE,
    marginTop: 30,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > span': {
      backgroundColor: '#FFFFFF',
      fontFamily: POPPINS,
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '130%',
      color: PERIWINKLE,
      padding: '8px 10px 10px',
    },
  },
  input: {
    width: 400,
    '& div': {
      fontFamily: POPPINS,
    },
  },
  emailInput: {
    marginTop: 30,
  },
  passwordInput: {},
  passwordInputWrapper: {
    marginTop: 10,
    position: 'relative',
  },
  eyeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: 20,
    top: 15,
  },
  termsAndPrivacy: {
    marginTop: 20,
    width: 400,
    paddingLeft: 40,
    boxSizing: 'border-box',
    position: 'relative',
  },
  termsCheckbox: {
    position: 'absolute',
    top: -4,
    left: -9,
  },
  termsAndPrivacyText: {
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '160%',
    color: SLATE_GREY,
    '& > a': {
      color: MIDNIGHT_EXPRESS,
      textDecoration: 'underline',
    },
  },
  button: {
    width: 400,
    marginTop: 20,
  },
  back: {
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '160%',
    color: SLATE_GREY,
    display: 'flex',
    alignItems: 'center',
    marginTop: 26,
    cursor: 'pointer',
    position: 'relative',
    '& span': {
      paddingLeft: 8,
    },
  },
  arrow: {
    position: 'absolute',
    left: '50%',
    '-webkit-transform': 'translateX(-50%)',
    transform: 'translateX(-50%)',
    top: 740,
    zIndex: -100,
  },
  error: {
    marginTop: 6,
    fontFamily: POPPINS,
    fontSize: 14,
    color: ERROR,
    fontWeight: 500,
    lineHeight: '160%',
    zIndex: 1,
    maxWidth: 350,
  },
  mobileHeader: {},
  exitIcon: {
    display: 'none',
  },
  form: {},
  '@media (max-width: 1024px)': {
    mainPart: {
      width: 'calc(100% - 330px)',
    },
    logo: {
      marginTop: 60,
    },
    header: {
      padding: '0 10px',
    },
  },
  '@media (max-width: 768px)': {
    mainPart: {
      width: 'calc(100% - 270px)',
    },
    header: {
      fontSize: 30,
      margin: 0,
    },
    googleButton: {
      width: 315,
    },
    orSeparator: {
      width: 315,
    },
    input: {
      width: 315,
    },
    button: {
      width: 315,
    },
    termsAndPrivacy: {
      width: 315,
    },
  },
  '@media (max-width: 640px)': {
    mainPart: {
      width: '100%',
      display: 'flex',
      height: '100%',
    },
    header: {
      marginTop: 10,
    },
    mobileHeader: {
      width: '100%',
      order: -1,
      height: 64,
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
      padding: '12px 20px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'space-between',
    },
    exitIcon: {
      display: 'inline-block',
      marginTop: 8,
    },
    back: {
      marginTop: 0,
      '& span': {
        display: 'none',
      },
    },
    signIn: {
      order: 1,
      position: 'static',
      marginTop: 15,
    },
    link: {
      textDecoration: 'underline',
    },
    logo: {
      marginTop: 43,
    },
    input: {
      '& div': {
        fontFamily: POPPINS,
        background: 'white',
      },
    },
    arrow: {
      display: 'none',
    },
  },
  '@media (max-width: 430px)': {
    header: {
      width: '84%',
      padding: 0,
    },
    mobileLabel: {
      display: 'block',
      width: '84%',
    },
    googleButton: {
      width: '84%',
    },
    orSeparator: {
      width: '84%',
    },
    form: {
      width: '84%',
      margin: '0 auto',
    },
    input: {
      width: '100%',
    },
    button: {
      width: '84%',
    },
    passwordInputWrapper: {
      width: '84%',
      '& .MuiFormControl-root': {
        width: '100%',
      },
    },
    termsAndPrivacy: {
      width: '84%',
    },
  },
}))

export default useStyles
